/* eslint-disable */
import AddLocationIcon from '@mui/icons-material/AddLocation'
import CloseIcon from '@mui/icons-material/Close'
import RadarIcon from '@mui/icons-material/Radar'
import SyncIcon from '@mui/icons-material/Sync'
import Button from '@mui/material/Button'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import ApiService from '../../../ApiService.js'
import { useStates } from '../../../StateProvider.js'
import { useViewPort } from '../../../ViewportProvider.js'
import { EMULATOR_DRAG_URL } from '../../../constants.js'
import { useEmulatorStore } from '../../../stores/emulator/store.tsx'

const MapButtons = (props) => {
  const { width } = useViewPort()
  const breakpoint = 620
  const isMobile = width < breakpoint

  const [address, setAddress] = useState({
    fromAddress: '',
    toAdress: ''
  })

  const pathTraveledRef = useRef(null)

  const getLatAndLng = () => {
    setAddress({
      ...address,
      fromAddress: localStorage.getItem('fromAddress'),
      toAdress: localStorage.getItem('toAddress')
    })
  }

  useEffect(() => {
    console.log('render component')
  }, [])

  const {
    showToast,
    setIsTableVisible,
    isTableVisible,
    isMoveDialogVisible,
    setIsMoveDialogVisible,
    setSearchFor,
    searchFor
  } = useStates()

  const cancelSetPositionButtonRef = React.createRef()
  const setPositionButtonRef = React.createRef()
  const createTripButtonRef = React.createRef()
  const cancelTripButtonRef = React.createRef()
  const viewToggleButtonRef = React.createRef()
  // MULTIPLE ROUTE_DATA
  const setDefaultTripPoints = useEmulatorStore(
    (state) => state.setDefaultPathPoints
  )
  const setAlternativeTripPoints = useEmulatorStore(
    (state) => state.setAlternativePathPoints
  )

  // TRIP DATA
  const tripDataRef = useRef(useEmulatorStore.getState().tripData)
  const cancelTripData = useEmulatorStore.getState().tripData

  useEffect(() => {
    if (cancelTripData === null) {
      tripDataRef.current = null
    }
  }, [tripDataRef, cancelTripData])

  // CONNECTED EMULATOR
  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )

  // MOVED EMULATOR
  const movedEmulatorRef = useRef(useEmulatorStore.getState().movedEmulator)
  const moveEmulator = useEmulatorStore((state) => state.moveEmulator)

  // DRAGGED EMULATORS
  const draggedEmulatorsRef = useRef(
    useEmulatorStore.getState().draggedEmulators
  )

  // GET SELECTED EMULATOR DATA
  const selectedEmulator = useEmulatorStore((state) => state.selectedEmulator)

  const handleSetPositionClick = () => {
    if (connectedEmulatorRef.current === null) {
      showToast('Emulator is not selected', 'error') // Emulator is not selected error
    } else {
      setIsMoveDialogVisible(!isMoveDialogVisible)
      setSearchFor('setPosition')
    }
  }

  const handleSetPositionCancelClick = () => {
    console.log('TEST@ handleSetPositionCancelClick')
    if (movedEmulatorRef.current !== null) {
      moveEmulator(null)
    }
    // if draggedEmulatorRef.current includes a dragEmulator of same dragEmulator.emulator.id
    // remove draggedEmulator from draggedEmulatorsRef.current
    const draggedEmulatorsList = draggedEmulatorsRef.current
    let didRemove = false
    draggedEmulatorsList.forEach((draggedEmulator, index) => {
      if (draggedEmulator.emulator.id === connectedEmulatorRef.current?.id) {
        draggedEmulatorsList.splice(index, 1)
        didRemove = true
      }
    })
    if (didRemove) {
      useEmulatorStore.setState({ draggedEmulators: [...draggedEmulatorsList] })
    }
    setupButtons()
  }

  const handleCreateTripButton = () => {
    if (connectedEmulatorRef.current === null) {
      showToast('Emulator is not selected', 'error') // Emulator is not selected error
    } else if (connectedEmulatorRef.current.AssignedTelephoneNumber === null) {
      showToast('Telephone Number is not Assigned', 'error') // Telephone Number is not Assigned
    } else {
      setIsTableVisible(!isTableVisible)
      setSearchFor('createTrip')
    }
  }

  const handleCancelTripClick = async () => {
    const token = localStorage.getItem('token')

    const payload = {
      emulatorId: connectedEmulatorRef.current?.id,
      cancelTrip: true,
      latitude: connectedEmulatorRef.current?.latitude,
      longitude: connectedEmulatorRef.current?.longitude,
      newTripIndex: null
    }

    const { success, error } = await ApiService.makeApiCall(
      EMULATOR_DRAG_URL,
      'POST',
      payload,
      token,
      null
    )

    if (success) {
      showToast('Trip has been cancelled', 'success')
      setDefaultTripPoints(0)
      setAlternativeTripPoints([0])
      // fetchEmulators();
      // NOTE: Don't need to refresh.. gets refreshed by SSE
    } else {
      console.error('Error cancelling trip', error)
      showToast('Trip Not cancelled', 'error')
    }
  }

  // function to set Button to be visible or not after checking it's existing visibility

  const setupButtons = useCallback(() => {
    const shouldShowCancelSetPosition = () => {
      // true if movedEmulator.moveMarker or if draggedEmulatorsRef.current includes a dragEmulator of same dragEmulator.emulator.id
      let shouldShow = false
      if (movedEmulatorRef.current?.moveMarker) {
        shouldShow = true
      }
      if (draggedEmulatorsRef.current.length > 0) {
        draggedEmulatorsRef.current.forEach((draggedEmulator) => {
          console.log(
            'TEST@ draggedEmulator',
            draggedEmulator.emulator.id,
            connectedEmulatorRef.current?.id
          )
          if (
            draggedEmulator.emulator.id === connectedEmulatorRef.current?.id
          ) {
            shouldShow = true
          }
        })
      }
      console.log('TEST@ shouldShow', shouldShow)
      return shouldShow
    }

    const setButtonVisibility = (buttonRef, isVisible) => {
      let display = 'none'
      if (isVisible) {
        display = 'block'
      }
      buttonRef.current.style.display = display
    }

    // For cancel Button
    const setButtonVisibilityCancelTrip = (buttonRef, isVisible) => {
      console.log('testEmulatorsData:', cancelTripData)
      let display = 'none'
      if (isVisible) {
        display = 'block'
      }
      buttonRef.current.style.display = display
    }
     const setButtonToggle = (buttonRef, isVisible) => {
      console.log('testEmulatorsData:', cancelTripData)
      let display = 'none'
      if (isVisible) {
        display = 'block'
      }
      buttonRef.current.style.display = display
    }
    // For Create trip button
    const setButtonVisibilityCreateTrip = (buttonRef, isVisible) => {
      let display = 'none'
      if (
        isVisible &&
        pathTraveledRef.current === null &&
        connectedEmulatorRef?.current?.user !== null
      ) {
        display = 'block'
      }
      buttonRef.current.style.display = display
    }

    // const alignButtons = () => {
    //   if (selectedEmulator?.user === null) {
    //     setPositionButtonRef.current.style.right = isMobile ? '5vw' : '390px'
    //   } else if (tripDataRef.current !== null) {
    //     setPositionButtonRef.current.style.right = isMobile ? '5vw' : '520px'
    //     cancelSetPositionButtonRef.current.style.right = isMobile
    //       ? '5vw'
    //       : '520px'
    //     cancelTripButtonRef.current.style.right = isMobile ? '29vw' : '390px'
    //   } else {
    //     setPositionButtonRef.current.style.right = isMobile ? '5vw' : '520px'
    //     setPositionButtonRef.current.style.left = isMobile ? '28vw' : ''
    //     cancelSetPositionButtonRef.current.style.right = isMobile
    //       ? '5vw'
    //       : '520px'
    //     cancelTripButtonRef.current.style.right = isMobile ? '5vw' : '390px'
    //   }
     const alignButtons = () => {
  const isTripActive = tripDataRef.current !== null;
  const isUserAssigned = selectedEmulator?.user !== null;

  // Helper: set right style safely
  const setRight = (ref, value) => {
    if (ref?.current) {
      ref.current.style.right = value;
    }
};

  // Helper: set left style safely
  const setLeft = (ref, value) => {
    if (ref?.current) {
      ref.current.style.left = value;
    }
  };

  // Handle viewToggleButton
  if (viewToggleButtonRef.current) {
    const rightValue = isMobile ? '5vw' : '400px';
    const shouldShow = !isTripActive;

    viewToggleButtonRef.current.style.display = shouldShow ? 'block' : 'none';
    viewToggleButtonRef.current.style.right = rightValue;
    viewToggleButtonRef.current.style.left = '';
  }

  // If user is NOT assigned
  if (!isUserAssigned) {
    setRight(setPositionButtonRef, isMobile ? '5vw' : '473px');
    setLeft(setPositionButtonRef, '');
    return; // Skip rest
  }

  // User assigned
  if (isTripActive) {
    setRight(setPositionButtonRef, isMobile ? '5vw' : '600px');
    setRight(cancelSetPositionButtonRef, isMobile ? '5vw' : '608px');
    setRight(cancelTripButtonRef, isMobile ? '29vw' : '473px');
    setLeft(setPositionButtonRef, '');
    setLeft(cancelSetPositionButtonRef, '');
    setLeft(cancelTripButtonRef, '');
  } else {
    // No trip, user assigned
    setRight(setPositionButtonRef, isMobile ? '5vw' : '601px');
    setLeft(setPositionButtonRef, isMobile ? '28vw' : '');

    setRight(cancelSetPositionButtonRef, isMobile ? '5vw' : '608px');
    setLeft(cancelSetPositionButtonRef, '');

    setRight(cancelTripButtonRef, isMobile ? '5vw' : '473px');
    setLeft(cancelTripButtonRef, '');

    // Show view toggle
    if (viewToggleButtonRef.current) {
      viewToggleButtonRef.current.style.right = isMobile ? '5vw' : '400px';
      viewToggleButtonRef.current.style.display = 'block';
    }
  }
};

    const showPositionButtons = connectedEmulatorRef.current !== null
    let showCancelSetPositionButton = false
    if (showPositionButtons) {
      showCancelSetPositionButton = shouldShowCancelSetPosition()
    }

    if (showCancelSetPositionButton) {
      cancelSetPositionButtonRef.current.innerText = isMobile
        ? 'X'
        : 'Cancel Set Position'
    }

    setButtonVisibility(
      cancelSetPositionButtonRef,
      showPositionButtons && showCancelSetPositionButton
    )

    setButtonVisibility(
      setPositionButtonRef,
      showPositionButtons && !showCancelSetPositionButton
    )

    setButtonVisibilityCreateTrip(
      createTripButtonRef,
      connectedEmulatorRef.current !== null
    )

    // console.log('cancelTripButtonRefNew:', tripDataRef)
    setButtonVisibilityCancelTrip(
      cancelTripButtonRef,
      tripDataRef.current !== null
    )
    alignButtons()
  }, [
    cancelSetPositionButtonRef,
    setPositionButtonRef,
    createTripButtonRef,
    cancelTripButtonRef,
    connectedEmulatorRef,
    tripDataRef,
    viewToggleButtonRef
  ])

  // subscribe to connectedEmulator
  useEffect(() => {
    return useEmulatorStore.subscribe(
      (state) => state.connectedEmulator,
      (connectedEmulator) => {
        connectedEmulatorRef.current = connectedEmulator
        setupButtons()
      }
    )
  }, [setupButtons])

  // subscribe to pathTraveled
  useEffect(() => {
    return useEmulatorStore.subscribe(
      (state) => state.pathTraveled,
      (pathTraveled) => {
        pathTraveledRef.current = pathTraveled
        setupButtons()
      }
    )
  }, [setupButtons])

  // subscribe to movedEmulator
  useEffect(() => {
    return useEmulatorStore.subscribe(
      (state) => state.movedEmulator,
      (movedEmulator) => {
        movedEmulatorRef.current = movedEmulator
        setupButtons()
      }
    )
  }, [setupButtons])

  // subscribe to Trip Data
  useEffect(() => {
    return useEmulatorStore.subscribe(
      (state) => state.tripData,
      (tripData) => {
        tripDataRef.current = tripData
        setupButtons()
      }
    )
  }, [setupButtons])

  // subscribe to draggedEmulators
  useEffect(() => {
    return useEmulatorStore.subscribe(
      (state) => state.draggedEmulators,
      (draggedEmulators) => {
        draggedEmulatorsRef.current = draggedEmulators
        setupButtons()
      }
    )
  }, [setupButtons])

  // timer for draggedEmulatorsOnCountdown
  useEffect(() => {
    const interval = setInterval(() => {
      const draggedEmulatorsList = draggedEmulatorsRef.current
      // loop index and reduce 1 from each draggedEmulator's timeout in draggedEmulatorsList
      draggedEmulatorsList.forEach(async (draggedEmulator, index) => {
        if (draggedEmulator.timeout > 0) {
          draggedEmulatorsList[index].timeout = draggedEmulator.timeout - 1
        }
        // if connectedEmulator was the one being dragged, set setShowCancelSetPosition to true

        if (draggedEmulator.emulator.id === connectedEmulatorRef.current?.id) {
          // change CANCEL SET POSITION text to CANCEL SET POSITION (timeout seconds left)
          if (cancelSetPositionButtonRef.current) {
            cancelSetPositionButtonRef.current.innerText = isMobile
              ? `X (${draggedEmulator.timeout}s)`
              : `Cancel Set Position (${draggedEmulator.timeout}s)`
          }
        }

        // if timeout reaches 0, remove the emulator from draggedEmulatorsList and set movedEmulator to null
        if (draggedEmulator.timeout === 0) {
          try {
            const token = localStorage.getItem('token')
            const payload = {
              emulatorId: draggedEmulator.emulator.id,
              cancelTrip: false,
              latitude: draggedEmulator.latitude,
              longitude: draggedEmulator.longitude,
              newTripIndex: null
            }

            const { success, error } = await ApiService.makeApiCall(
              EMULATOR_DRAG_URL,
              'POST',
              payload,
              token,
              null
            )

            if (success) {
              showToast(
                `Location Updated for emulator with number ${
                  draggedEmulator.emulator.telephone
                    ? draggedEmulator.emulator.telephone
                    : 'N/A'
                }.`,
                'success'
              )
              // remove from draggedEmulatorsList
              draggedEmulatorsList.splice(index, 1)
              // fetchEmulators();
              // NOTE: Don't need to refresh.. gets refreshed by SSE
              // But since we are not updating the state, and subscribe only responds to added draggedEmulators.
              // we need to update the buttons right now from here
              setupButtons()
              cancelSetPositionButtonRef.current.innerText = isMobile
                ? 'X'
                : 'Cancel Set Position'
              moveEmulator(null)
            } else {
              throw new Error(error)
            }
          } catch (error) {
            if (draggedEmulator.retries > 5) {
              showToast(
                `Error updating location for emulator ID ${draggedEmulator.emulator.id}. Retries exceeded. Resetting to Original Location!.` +
                  error,
                'error'
              )
              console.error(
                'Error updating location for emulator ID',
                draggedEmulator.emulator.id,
                '. Retries exceeded. Removing from list.',
                error
              )
              draggedEmulatorsList.splice(index, 1)
              // since we are not updating the state, and subscribe only responds to added draggedEmulators.
              // we need to update the buttons right now from here
              setupButtons()
            } else {
              showToast(
                `Error updating location for emulator ID ${draggedEmulator.emulator.id}. Retrying in 5 seconds.` +
                  error,
                'error'
              )
              console.error(
                'Error updating location for emulator ID',
                draggedEmulator.emulator.id,
                '. Retrying in 5 seconds.',
                error
              )
              draggedEmulatorsList[index].timeout = 5
              draggedEmulatorsList[index].retries =
                draggedEmulatorsList[index].retries + 1
            }
          }
        }
      })
      useEmulatorStore.setState({ draggedEmulators: draggedEmulatorsList }) // Shallow update. State change won't be detected.
    }, 1000)
    return () => clearInterval(interval)
  }, [cancelSetPositionButtonRef, showToast])

  return (
    <>
      <div
  style={{
    ...(isMobile && {
      position: 'absolute',
      top: '17px',
      right: '5vw',
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      zIndex: 2,
    }),
  }}
>
   <div>
  <Button
    ref={setPositionButtonRef}
    variant="contained"
    style={{
      display: 'none',
      height: '35px',
      width: isMobile ? '35px' : '125px',
      zIndex: 2,
      position: isMobile ? 'static' : 'absolute',
      top: isMobile ? undefined : '20px',
      right: isMobile ? undefined : '608px',
      justifyContent: 'center',
      backgroundColor: '#2C6FEB',
      textTransform: 'capitalize',
    }}
    onClick={handleSetPositionClick}
  >
    {isMobile ? <RadarIcon /> : 'Set position'}
  </Button>

  <Button
    ref={cancelSetPositionButtonRef}
    variant="contained"
    style={{
      display: 'none',
      height: '35px',
      width: isMobile ? '35px' : '125px',
      zIndex: 2,
      position: isMobile ? 'static' : 'absolute',
      top: isMobile ? undefined : '20px',
      right: isMobile ? undefined : '608px',
      justifyContent: 'center',
      backgroundColor: '#FF4D00',
      textTransform: 'capitalize',
    }}
    onClick={handleSetPositionCancelClick}
  >
    {isMobile ? <CloseIcon /> : 'Cancel Set Position'}
  </Button>
  
  <Button
    ref={createTripButtonRef}
    variant="contained"
    style={{
      display: 'none',
      height: '35px',
      width: isMobile ? '35px' : '125px',
      zIndex: 2,
      position: isMobile ? 'static' : 'absolute',
      top: isMobile ? undefined : '20px',
      // right: isMobile ? undefined : '392px',
      right: isMobile ? undefined : '473px',
      justifyContent: 'center',
      backgroundColor: '#2C6FEB',
      textTransform: 'capitalize',
    }}
    onClick={handleCreateTripButton}
  >
    {isMobile ? <AddLocationIcon /> : 'Create Trip'}
  </Button>

  <Button
    ref={cancelTripButtonRef}
    variant="contained"
    data-bs-toggle="modal"
    data-bs-target="#cancelTripModal"
    style={{
      display: 'none',
      height: '35px',
      width: isMobile ? '35px' : '125px',
      zIndex: 2,
      position: isMobile ? 'static' : 'absolute',
      top: isMobile ? undefined : '20px',
      right: isMobile ? undefined : '475px',
      justifyContent: 'center',
      backgroundColor: '#2C6FEB',
      textTransform: 'capitalize',
    }}
    onClick={getLatAndLng}
  >
    {isMobile ? <CloseIcon /> : 'Cancel Trip'}
  </Button>

  <Button
    variant="contained"
    style={{
      width: isMobile ? '35px' : '30px',
      height: '35px',
      zIndex: 2,
      position: isMobile ? 'static' : 'absolute',
      top: isMobile ? undefined : '20px',
      // right: isMobile ? undefined : '320px',
      right: isMobile ? undefined : '406px',
      justifyContent: 'center',
      backgroundColor: '#2C6FEB',
    }}
    onClick={props?.handleButtonClick}
  >
    <SyncIcon
      sx={{
        width: '22px',
        height: '22px',
        transition: 'transform 1s ease-in-out',
        transform: props?.isSpinning ? 'rotate(360deg)' : '',
      }}
    />
  </Button>
  </div>
</div>


      {/* Cancel Trip Modal */}
      <div className="modal" id="cancelTripModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">Cancel Trip</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to cancel{' '}
              <strong>{address?.fromAddress}</strong> to{' '}
              <strong>{address?.toAdress}</strong> trip?
            </div>

            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() => handleCancelTripClick()}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MapButtons
